import React, { Component } from "react";

import { PropertyPanelContainer } from "js/EditorComponents/PropertyPanel";
import { ShowDialog, ShowDialogAsync, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";
import { _ } from "js/vendor";
import styled from "styled-components";
import { CanvasEventType } from "../../../common/constants";
import { CategoryController } from "../../../common/SlideCategories/CategoryController";
import { computeChangeSet, mergeChanges } from "../../../common/utils/changeset";
import { findElementsWithImages } from "../../../common/utils/findElementsWithImages";
import { ToolTipBadge } from "../../Components/ToolTip";
import AiGenerationService from "../../core/services/aiGeneration";
import { PropertyPanelButton } from "../../EditorComponents/PropertyPanelButton";
import CanvasPreview from "../../react/components/CanvasPreview";
import Spinner from "../../react/components/Spinner";
import { themeColors } from "../../react/sharedStyles";
import { RegenerateImageDialog } from "../AiGeneration/GenerateImage/RegenerateImageDialog";
import { PropertyPanelHeader } from "../ElementEditor/PropertyPanelHeader";
import PresentationEditorController from "../PresentationEditor/PresentationEditorController";
import { SlideAiDialog } from "./SlideAiDialog";

const Container = styled.div`
    padding: 10px 15px;
    width: 100%;
`;

const ScrollBox = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    width: 100%;
    overflow-x: scroll;
`;

const SlideCategory = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
`;

const SlidePreviews = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding-bottom: 10px;
`;

const CategoryLabel = styled.div`
    display: flex;
    font-weight: bold;
    padding: 10px 0px 0px;
    align-items: center;
    justify-content: center;
`;

const CanvasPreviewWrapper = styled.div`
    position: relative;
    width: 200px;
    height: 112.5px;
    cursor: pointer;
    border: solid 1px #ccc;
    overflow: hidden;
    outline: ${props => props.selected ? `3px solid ${themeColors.ui_blue}` : "none"};
`;

export class SlideAiVariationsPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentModel: _.cloneDeep(props.currentSlide.attributes),
            isGenerating: false,
            selectedModel: null,
            textDensity: 1,
            slideCategory: null,
            slideCategories: []
        };

        this.hasBeenUnmounted = false;
    }

    componentDidMount() {
        const { currentSlide } = this.props;
        // if (currentSlide.getMetadata()?.hasBeenViewed === false) {
        currentSlide.updateMetadata({ hasBeenViewed: true });
        this.setState({ slideGen: currentSlide.getMetadata() });
        this.renderSlideModels(currentSlide.getMetadata()?.generatedSlides ?? [], true);
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        const { canvasController, currentSlide } = this.props;
        const { textDensity } = this.state;

        if (prevProps.currentSlide !== currentSlide) {
            this.setState({
                currentModel: _.cloneDeep(currentSlide.attributes),
                isGenerating: false,
                selectedModelIndex: null,
                slideCategory: null
            });
        }
    }

    componentWillUnmount() {
        this.hasBeenUnmounted = true;
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.canvasController?.canvas?.isAnimating;
    }

    setStateAsync = async stateUpdate => {
        await new Promise(resolve => this.setState(stateUpdate, resolve));
    }

    // handleRegenerateSlide = () => {
    //     const { currentSlide, currentCanvasController } = this.props;
    //     ShowDialog(SlideAiDialog, { slide: currentSlide, canvas: currentCanvasController.canvas, onClose: this.regenerateSlide });
    // }
    //
    // handleRegenerateImage = async () => {
    //     const { currentSlide, currentTheme } = this.props;
    //
    //     const metadata = currentSlide.getMetadata();
    //     const slideImage = metadata.generatedModel?.slideImage;
    //     const imageSource = metadata.imageSource ?? "ai";
    //
    //     let { imagePrompt, imageStyle } = await ShowDialogAsync(RegenerateImageDialog, {
    //         currentSlide,
    //         theme: currentTheme,
    //         prompt: slideImage?.prompt || "",
    //         imageSource: imageSource,
    //         imageStyle: slideImage?.imageStyle || "minimalist",
    //     });
    //
    //     if (!imagePrompt) {
    //         return;
    //     }
    //
    //     imageStyle = imageStyle || slideImage?.imageStyle || "";
    //
    //     await currentSlide.resetSlideImage();
    //
    //     const generatedSlides = currentSlide.getMetadata()?.generatedSlides;
    //     this.renderSlideModels(generatedSlides, true);
    //
    //     const { slide } = await AiGenerationService.regenerateSlideImage({
    //         slide: currentSlide.attributes,
    //         imagePrompt,
    //         imageStyle
    //     });
    //
    //     currentSlide.update(slide);
    //     await currentSlide.updatePromise;
    //
    //     this.renderSlideModels(generatedSlides, true);
    // }
    //
    // regenerateSlide = async slideGen => {
    //     if (!slideGen) return;
    //
    //     const { currentSlide } = this.props;
    //
    //     this.setState({
    //         currentModel: _.cloneDeep(currentSlide.attributes),
    //         isGenerating: true,
    //         selectedModelIndex: 0,
    //     });
    //
    //     currentSlide.update({ metadata: { ...currentSlide.getMetadata(), ...slideGen } });
    //     console.log("Regenerating slide with state:", slideGen);
    //
    //     let response = await AiGenerationService.generateSlideData({
    //         slideId: currentSlide.id,
    //         presentationId: currentSlide.presentation.id,
    //         slidePrompt: slideGen.slidePrompt,
    //         slideType: slideGen.slideType,
    //         slideIndex: currentSlide.getIndex(),
    //         preserveExactText: slideGen.preserveExactText || false,
    //         files: slideGen.files || [],
    //         presentationTopic: currentSlide.presentation.get("metadata").topic
    //     });
    //
    //     console.log(response);
    //
    //     if (!response.slides || response.slides.length == 0) {
    //         ShowWarningDialog({ title: "Slide AI", message: "Sorry, we couldn't generate a new slide for you. Please try again." });
    //         this.setState({ isGenerating: false });
    //         return;
    //     }
    //
    //     this.renderSlideModels(response.slides, slideGen.slidePrompt);
    // }

    renderSlideModels = async (generatedSlides, slidePrompt) => {
        const { currentSlide } = this.props;

        let slideCategories = [];
        for (let slide of generatedSlides) {
            let slideModel = slide.slideData;
            slideModel.slideImage = currentSlide.getMetadata().generatedModel?.slideImage;
            slideModel.imageStylePrompt = currentSlide.getMetadata().imageStylePrompt;

            console.log("Category", slideModel.slideCategory);
            console.log("Reasoning:", slideModel.slideReasoning);
            console.log(slideModel);

            let category = CategoryController.getCategory(slideModel.slideCategory);
            let models = category.getSlideModels(slideModel);

            // copy over metadata from the generated slide data
            models = models.map(model => ({
                ...model,
                metadata: {
                    ...currentSlide.getMetadata(),
                    ...model.metadata,
                    generatedSlides,
                    aiGenerated: true,
                    originalSlidePrompt: slidePrompt,
                    slidePrompt: slideModel.slidePrompt,
                    slideCategory: slideModel.slideCategory,
                    slideReasoning: slideModel.slideReasoning,
                    slideConfidence: slideModel.slideConfidence
                }
            }));

            models.forEach(model => {
                let elementsWithImages = findElementsWithImages(model);
                for (let element of elementsWithImages) {
                    if (!element.content_value && element.__generateImage) {
                        element.__generateImage.isGenerating = true;
                    }
                }
            });

            slideCategories.push({
                slideCategory: slideModel.slideCategory,
                slideReasoning: slideModel.slideReasoning,
                slideConfidence: slideModel.slideConfidence,
                models
            });
        }

        await this.setStateAsync({
            slideCategories,
            isGenerating: false
        });

        for (let cat of slideCategories) {
            let models = cat.models;
            for (let idx = 0; idx < models.length; idx++) {
                let { slide } = await AiGenerationService.generateImagesForSlide({
                    slide: models[idx]
                });

                if (this.state.slideCategories !== slideCategories || this.hasBeenUnmounted) {
                    // If the preview models have changed or the component has been unmounted, stop generation
                    break;
                }

                let { update, hasUpdates } = computeChangeSet(models[idx], slide);
                if (hasUpdates) {
                    let updatedModel = mergeChanges(models[idx], update);
                    this.setState(state => {
                        // Keep the array reference, only replace a single model
                        const slideCategories = state.slideCategories;
                        slideCategories[slideCategories.indexOf(cat)].models[idx] = updatedModel;
                        return {
                            ...state,
                            slideCategories
                        };
                    });
                }
            }
        }
    }

    handleApplySlide = model => {
        const { currentSlide, currentCanvasController } = this.props;
        const { slideGen } = this.state;

        currentCanvasController.canvas.once(CanvasEventType.REFRESH, () => {
            window.requestAnimationFrame(() => {
                PresentationEditorController.playAnimation();
            });
        });

        currentSlide.update({
            ...currentSlide.attributes,
            animations: {},
            states: model.states,
            layout: model.layout,
            template_id: model.template_id,
            version: 10,
            migrationVersion: 10.03,
            metadata: {
                ...slideGen,
                ...model.metadata,
                needsLayoutProcessing: true
            }
        }, { removeMissingKeys: true });

        this.setState({ selectedModel: model });
    }

    render() {
        const { currentSlide } = this.props;
        const { isGenerating, selectedModel, slideCategories } = this.state;

        return (
            <Container>
                <ScrollBox>
                    {/*<CategoryLabel>Original Slide</CategoryLabel>*/}
                    {/*<CanvasPreviewWrapper selected={selectedModel == currentModel} onClick={() => this.handleApplySlide(currentModel)} key="current">*/}
                    {/*    <CanvasPreview slideModel={currentModel} width={260} />*/}
                    {/*</CanvasPreviewWrapper>*/}

                    {slideCategories.map(category => (
                        <SlideCategory>

                            <CategoryLabel>{category.slideCategory.replace("_", " ").toTitleCase()} slides&nbsp;&nbsp;
                                <ToolTipBadge><strong>Why did we suggest {category.slideCategory.replace("_", " ").toTitleCase()} slides? ({category.slideConfidence}% match)</strong><br /><br />{category.slideReasoning}</ToolTipBadge>
                            </CategoryLabel>

                            <SlidePreviews>
                                {category.models.map((model, index) => (
                                    <CanvasPreviewWrapper selected={selectedModel == model} onClick={() => this.handleApplySlide(model)} key={index}>
                                        <CanvasPreview slideModel={model} width={200} />
                                    </CanvasPreviewWrapper>
                                ))}
                            </SlidePreviews>
                        </SlideCategory>
                    ))}
                </ScrollBox>
            </Container>
        );
    }
}

